(function () {
  'use strict';

  var jointUrl = '/products/p-vetkor-advanced-dog-hip-and-joint-supplement-with-glucosamine-chondroitin-omega-3-msm-andgreen-lipped-mussel-60-chicken-flavored-chews-for-small-medium-and-large-dog-breeds';
  var coatUrl = '/products/pvetkor-skin-and-coat-supplement-for-dogs-100-natural-omega-3-colostrum-soft-chews-for-itchy-skin-anti-shedding-shiny-fur-chicken-flavor-100-count';

  function init(root) {
    if (!root || root.dataset.pvQuizReady === 'true') return;
    var emailStep = root.querySelector('[data-pv-quiz-email]');
    var quizStep = root.querySelector('[data-pv-quiz-questions]');
    var resultStep = root.querySelector('[data-pv-quiz-result]');
    var emailForm = root.querySelector('[data-pv-quiz-email-form]');
    var quizForm = root.querySelector('[data-pv-quiz-form]');
    var emailStatus = root.querySelector('[data-pv-quiz-email-status]');
    if (!emailStep || !quizStep || !resultStep || !emailForm || !quizForm) return;
    root.dataset.pvQuizReady = 'true';

    var frame = document.createElement('iframe');
    frame.name = 'pv-quiz-submit-frame';
    frame.title = 'Newsletter signup';
    frame.setAttribute('aria-hidden', 'true');
    frame.style.display = 'none';
    document.body.appendChild(frame);
    emailForm.setAttribute('target', frame.name);

    quizForm.innerHTML = '<fieldset style="margin:0 0 22px;padding:0;border:0"><legend style="margin-bottom:10px;font-weight:700">How serious is your dog\'s shedding?</legend>' +
      '<label style="display:block;padding:9px 0"><input type="radio" name="shedding" value="none" required> Normal seasonal shedding</label>' +
      '<label><input type="radio" name="shedding" value="mild"> A little more than usual</label>' +
      '<label><input type="radio" name="shedding" value="moderate"> Noticeable hair around the home</label>' +
      '<label><input type="radio" name="shedding" value="severe"> Heavy shedding or thinning coat</label></fieldset>' +
      '<fieldset style="margin:0 0 22px;padding:0;border:0"><legend style="margin-bottom:10px;font-weight:700">How active is your dog?</legend>' +
      '<label><input type="radio" name="activity" value="active" required> Active and playful</label>' +
      '<label><input type="radio" name="activity" value="less"> Less active than before</label>' +
      '<label><input type="radio" name="activity" value="stiff"> Stiff, slow, or hesitant on walks</label></fieldset>' +
      '<fieldset style="margin:0 0 22px;padding:0;border:0"><legend style="margin-bottom:10px;font-weight:700">What is your dog\'s life stage?</legend>' +
      '<label><input type="radio" name="age" value="young" required> Puppy or young adult</label>' +
      '<label><input type="radio" name="age" value="adult"> Adult</label>' +
      '<label><input type="radio" name="age" value="senior"> Senior or older dog</label></fieldset>' +
      '<button type="submit" style="width:100%;padding:15px;border:0;border-radius:999px;background:#f47721;color:#fff;font:inherit;font-weight:800;cursor:pointer">Show my personalized recommendation</button>';

    emailForm.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var input = emailForm.querySelector('input[type="email"]');
      if (!input || !input.value.trim()) { if (input) input.reportValidity(); return; }
      var submit = emailForm.querySelector('button');
      if (submit) submit.disabled = true;
      emailStatus.textContent = 'Your guide is ready.';
      emailStep.hidden = true;
      quizStep.hidden = false;
      quizStep.removeAttribute('hidden');
      var first = quizForm.querySelector('input[type="radio"]');
      if (first) first.focus();
      fetch(emailForm.action || '/contact', { method: 'POST', body: new FormData(emailForm), credentials: 'same-origin', headers: { Accept: 'text/html' } }).catch(function () {});
    });

    quizForm.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!quizForm.checkValidity()) { quizForm.reportValidity(); return; }
      var data = new FormData(quizForm);
      var shedding = data.get('shedding');
      var activity = data.get('activity');
      var age = data.get('age');
      var coatTwo = shedding === 'moderate' || shedding === 'severe';
      var jointTwo = activity === 'less' || activity === 'stiff' || age === 'senior';
      var coatQty = coatTwo ? 2 : 1;
      var jointQty = jointTwo ? 2 : 1;
      var hasConcern = coatTwo || jointTwo;
      var intro = hasConcern ? 'Based on your answers, your dog would benefit from targeted daily support.' : 'Your dog looks well balanced today. A simple preventive routine can help keep it that way.';
      var jointCopy = jointTwo ? 'We recommend two bottles of Joint + Mobility to support comfortable movement and help protect an aging or less active body.' : 'One bottle of Joint + Mobility is a gentle preventive foundation for active days.';
      var coatCopy = coatTwo ? 'We recommend two bottles of Skin + Coat to support a healthier coat and help reduce noticeable shedding.' : 'One bottle of Skin + Coat helps maintain a healthy coat and supports prevention before shedding becomes a concern.';
      resultStep.innerHTML = '<p>Your personalized wellness guide</p><h2>' + intro + '</h2>' +
        '<p class="pv-quiz-result-lead">We suggest <strong>' + jointQty + ' bottle' + (jointQty > 1 ? 's' : '') + '</strong> of Joint + Mobility and <strong>' + coatQty + ' bottle' + (coatQty > 1 ? 's' : '') + '</strong> of Skin + Coat.</p>' +
        '<div class="pv-quiz-results-grid"><a href="' + jointUrl + '"><strong>Joint + Mobility</strong><span>' + jointCopy + '</span><b>View product</b></a><a href="' + coatUrl + '"><strong>Skin + Coat</strong><span>' + coatCopy + '</span><b>View product</b></a></div>' +
        '<p class="pv-quiz-note">This guide is for general wellness education and is not a veterinary diagnosis.</p>';
      quizStep.hidden = true;
      resultStep.hidden = false;
      resultStep.removeAttribute('hidden');
      resultStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function scan() { document.querySelectorAll('[data-pv-health-quiz]').forEach(init); }
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.setTimeout(scan, 250);
  window.setTimeout(scan, 1000);
}());
